
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"13","viewBox":"0 0 10 13","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.887 13H1.69a.615.615 0 01-.613-.574L.545 4.52a.615.615 0 01.614-.656h7.26c.355 0 .637.302.613.656L8.5 12.426a.615.615 0 01-.613.574zM9.639 2.712H.015c-.01 0-.015-.005-.015-.014V1.015C0 1.005.006 1 .015 1h9.624c.008 0 .014.006.014.015v1.681c0 .01-.006.016-.014.016z"}}),_c('path',{attrs:{"d":"M7.158 1.942H2.015c-.01 0-.015-.005-.015-.014V.015C2 .005 2.006 0 2.015 0h5.143c.008 0 .014.006.014.015v1.913a.015.015 0 01-.014.014z"}})])
          )
        }
      }
    